import React, { useState, useEffect } from 'react'
import { useLanguage } from '../../i18n/LanguageContext'

const NAV_LABELS = {
  ja: { home: 'ホーム', about: 'プロフィール', skill: 'スキル', experience: '職務経歴', work: '個人開発', contact: 'お問い合わせ' },
  zh: { home: 'Home', about: 'About', skill: 'Skill', experience: 'Experience', work: 'Works', contact: 'Contact' },
}

export default function Header() {
  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const [currentSection, setCurrentSection] = useState(null);
  const { lang, setLang } = useLanguage();
  const labels = NAV_LABELS[lang];

  const handleScroll = () => {
    const sections = document.querySelectorAll('section'); // 假設您的 section 使用標籤為 <section>
    
    for (const section of sections) {
      const rect = section.getBoundingClientRect();
      if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
        setCurrentSection(section.id);
        break; // 如果找到在視窗中的第一個 section，可以提前結束迴圈
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header>
      <nav className="navbar">
        <div className="navbar__container">
          <a href="#home" id="navbar__logo">By Mako</a>
          <div className={`navbar__toggle ${mobileMenuActive?' is-active': ''}`} id="mobile-menu" onClick={()=>setMobileMenuActive(!mobileMenuActive)}>
            <span className='bar'></span> <span className="bar"></span>
            <span className="bar"></span>
          </div>
          <ul className={`navbar__menu ${mobileMenuActive ? ' menuActive': ''}`}>
            <li className={`navbar__item ${currentSection==='home' ? ' active': ''}`}>
              <a href="#home" className="navbar__links" id="home-page">{labels.home}</a>
            </li>
            <li className={`navbar__item ${currentSection==='about' ? ' active': ''}`}>
              <a href="#about" className="navbar__links" id="about-page">{labels.about}</a>
            </li>
            <li className={`navbar__item ${currentSection==='skill' ? ' active': ''}`}>
              <a href="#skill" className="navbar__links" id="skill-page">{labels.skill}</a>
            </li>
            <li className={`navbar__item ${currentSection==='experience' ? ' active': ''}`}>
              <a href="#experience" className="navbar__links" id="experience-page">{labels.experience}</a>
            </li>
            <li className={`navbar__item ${currentSection==='work' ? ' active': ''}`}>
                <a href="#work" className="navbar__links" id="portfolio-page">{labels.work}</a>
              </li>
            <li className="navbar__item navbar__item--lang">
              <button type="button" className={`langBtn ${lang==='ja' ? ' langBtn--active' : ''}`} onClick={() => setLang('ja')}>日本語</button>
              <span className="langDivider">|</span>
              <button type="button" className={`langBtn ${lang==='zh' ? ' langBtn--active' : ''}`} onClick={() => setLang('zh')}>中文</button>
            </li>
            <li className={`navbar__itemButton ${currentSection==='contact' ? ' active': ''}`}>
              <div className='navbar__btn'>
              <a href="#contact" className="button" id="Contact">{labels.contact}</a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  )
}
